export const backendurl = "https://ax.51i.cc";
export const frontendurl = "https://astig.51i.cc";
